export default {
  active_slide_image_change($slide) {
    const $active_slide_image = $('#active_slide_image');
    const active_slide_imge_src = $slide.find('.slide_image').attr('data-src');

    if ( $slide.next('.swiper-slide').length ) {
      $active_slide_image.addClass('transitioning');
    }

    setTimeout(() => {
      $active_slide_image.attr('src', active_slide_imge_src);
      $active_slide_image.removeClass('transitioning');
    }, 200);
  },
  init() {
    const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const $timeline_swiper_slide = $('.timeline-swiper .swiper-slide');
    let interval = 0;

    if ( !$timeline_swiper_slide.length ) {
      return;
    }

    $timeline_swiper_slide.removeClass('is_open');
    $timeline_swiper_slide.first().addClass('is_open');

    if ( vw < 1024 ) {
      const timeline_swiper = new Swiper ('.timeline-swiper', {
        slidesPerView: '5',
        centeredSlides: true,
        spaceBetween: 0,
        initialSlide: 5,
        on: {
          'click': function() {
            timeline_swiper.slideTo( timeline_swiper.clickedIndex );
          },
        },
        breakpoints: {
          640: {
            slidesPerView: 'auto',
          },
          1024: {
            slidesPerView: 'auto',
            centeredSlides: false,
          },
        },
      });
      let slide_to = 0;

      timeline_swiper.slideTo( slide_to );

      interval = setInterval(() => {
        const $opened_slide = $('.timeline-swiper .swiper-slide.is_open');

        if ( slide_to < timeline_swiper.slides.length - 1 ) {
          slide_to++;
          $opened_slide.removeClass('is_open');
        } else {
          clearInterval(interval);
        }

        timeline_swiper.slideTo( slide_to );
        $opened_slide.next('.swiper-slide').addClass('is_open');

      }, 3000);

    } else {
      this.active_slide_image_change($timeline_swiper_slide.first());
      interval = setInterval(() => {
        const $opened_slide = $('.timeline-swiper .swiper-slide.is_open');

        $opened_slide.next('.swiper-slide').addClass('is_open');
        this.active_slide_image_change($opened_slide.next('.swiper-slide'));

        if ( $opened_slide.next('.swiper-slide').length ) {
          $opened_slide.removeClass('is_open');
        } else {
          clearInterval(interval);
        }

      },3000);
    }

    $timeline_swiper_slide.on('click', function() {
      const $active_slide_image = $('#active_slide_image');

      if ( interval !== 0 ) {
        clearInterval(interval);
      }

      $active_slide_image.addClass('transitioning');
      $timeline_swiper_slide.removeClass('is_open');

      setTimeout(() => {
        $(this).toggleClass('is_open');
        $active_slide_image.attr('src', $(this).find('.slide_image').attr('data-src'));
        $active_slide_image.removeClass('transitioning');
      }, 200);
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/modules/timeline.js